<!--<form (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm" fxLayout="row" >
  <mat-form-field appearance="outline" fxFlex="100">
    <mat-label></mat-label>
    &lt;!&ndash;<input formControlName="entityType" matInput placeholder="" required>&ndash;&gt;
    <mat-select formControlName="value" (selectionChange)="onSelectionChange($event)" >
      <mat-option *ngFor="let data of list" [value]="data">
        {{data.title}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</form>-->


<form (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm"
      class="flex flex-col full-grow-no-shrink-no-basis">
  <!--<mat-form-field appearance="outline" fxFlex="100" fxLayout="column">
    <mat-label>Export Type</mat-label>
    <input matInput placeholder="Input" style="display: none" formControlName="exportTypeFormCtrl"
           particleAnalytics
           analyticsCategory= "export-type"
           analyticsAction= "export-type-input" required>
    <mat-radio-group fxLayout="column"
                     aria-label="Select an option"
                     (change)="onExportTypeChanged()">
      <mat-radio-button *ngFor="let exportType of exportTypes; let i = index" class="m-b-10" [checked]="exportType===selectedExportType"
                        [value]="exportType"
                        [disabled]="i>0">
        Export to {{exportType}}
      </mat-radio-button>
    </mat-radio-group>
  </mat-form-field>-->

  <mat-form-field class="w-p-100" floatPlaceholder="always" floatLabel="always" appearance="outline">
    <mat-label>Select Topic(s)&nbsp;*</mat-label>
    <input matInput placeholder="Input" style="display: none"
           particleAnalytics
           analyticsCategory="choice-filter-modal-item-editor"
           analyticsAction="entity-scope-input">

    <mat-checkbox *ngFor="let data of list" [value]="data" class="flex flex-col" (click)="onTopicSelectionChange(data)"
                  [checked]="true">
      {{data.name}}
    </mat-checkbox>
  </mat-form-field>
</form>
